// Rosemary theme JS entry

// Import ALL Bootstrap JS (tree-shaken per your bundler). You can comment out what you don't need.
//import 'bootstrap/js/dist/alert';
import 'bootstrap/js/dist/button';
//import 'bootstrap/js/dist/carousel';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
//import 'bootstrap/js/dist/modal';
//import 'bootstrap/js/dist/offcanvas';
//import 'bootstrap/js/dist/popover';
//import 'bootstrap/js/dist/scrollspy';
//import 'bootstrap/js/dist/tab';
//import 'bootstrap/js/dist/toast';
//import 'bootstrap/js/dist/tooltip';

// Example: enable tooltips if you keep them
document.addEventListener('DOMContentLoaded', () => {
  const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
  tooltipTriggerList.forEach(el => {
    try {
      // eslint-disable-next-line no-new
      new (require('bootstrap/js/dist/tooltip'))(el);
    } catch (e) {}
  });
});

import Velocity from 'velocity-animate';

// Your custom modules
// import './modules/my-custom';

document.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('.site-header.sticky-top');
    if (!header) return;

    // Create a tiny invisible sentinel above the header
    const sentinel = document.createElement('div');
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.style.position = 'absolute';
    sentinel.style.top = '0';
    sentinel.style.width = '100%';
    sentinel.style.height = '1px';
    header.before(sentinel);

    // Observe when the sentinel leaves/enters the viewport
    const observer = new IntersectionObserver(
        ([entry]) => {
            header.classList.toggle('is-stuck', entry.intersectionRatio === 0);
        },
        { threshold: [0, 1] }
    );

    observer.observe(sentinel);
});

jQuery(document).ready(function ($) {
    var Togz = $(".navbar-toggler");
    var tog1 = Togz.find("b:nth-child(1)");
    var tog2 = Togz.find("b:nth-child(2)");
    var tog3 = Togz.find("b:nth-child(3)");

    Togz.toggleClass("collapsed");

    Togz.click(function () {
        if (Togz.hasClass("collapsed")) {
            Togz.velocity("reverse");
            tog3.velocity({ rotateZ: "0deg" }, { duration: 800, easing: [500, 20] })
                .velocity({ top: "100%" }, { duration: 200, easing: "swing" });
            tog1.velocity("reverse", { delay: 800 });
        } else {
            tog1.velocity({ top: "50%" }, { duration: 200, easing: "swing" });
            tog3.velocity({ top: "50%" }, { duration: 200, easing: "swing" })
                .velocity({ rotateZ: "90deg" }, { duration: 800, delay: 200, easing: [500, 20] });
            Togz.velocity({ rotateZ: "135deg" }, { duration: 800, delay: 200, easing: [500, 20] });
        }
    });
});